<template>
  <LinkCard :image="thumbnail" :title="$path('name', value)" :subtitle="subtitle" :to="$attrs.to" :is-list="isList" />
</template>

<script>
import LinkCard from '@/components/LinkCard'
import StatusIndicator from '@/components/StatusIndicator'

import { Currency } from '@/filters'

export default {
  props: {
    value: Object,
    theme: {
      type: String,
      enum: ['default', 'list'],
      default: 'default',
    },
  },
  computed: {
    isList() {
      return this.theme === 'list'
    },
    subtitle() {
      return Currency(this.value.sale.value, { currency: this.value.project.metadata.currency })
    },
    thumbnail() {
      let item = (this.$path('value.media.cover') || []).find(({ type }) => type.startsWith('image'))
      if (!item) return

      return { src: item.url, alt: this.value.name }
    },
    badges() {
      if (this.value.isEntry) return [{ theme: 'primary', value: this.$t('unitSelectorIsEntry') }]
      return []
    },
  },
  components: {
    LinkCard,
    StatusIndicator,
  },
}
</script>
